import React from "react";
import ReactDOM from "react-dom/client"; // Updated import
import "semantic-ui-css/semantic.min.css";
import "./css/index.css";
import MainHome from "./main/MainHome";

import Home from "./main/Home";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { MobileProvider } from "./MobileContext";
import Constants from "./util/Constants";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container); // Create the root

root.render(
  <GoogleOAuthProvider clientId={Constants.GOOGLE_CLIENT_ID}>
    <MobileProvider>
      <MainHome />
    </MobileProvider>
  </GoogleOAuthProvider>
);
